/**
 * 重定向循环检测工具
 *
 * 当外部认证 URL 配置错误（例如指向了自身）时，
 * 会导致无限重定向循环。此模块通过 sessionStorage
 * 记录短时间窗口内的重定向次数来检测并中断循环。
 */

const LOOP_CHECK_KEY = 'auth_loop_count';
const LOOP_CHECK_TIME = 'auth_loop_time';

/** 10 秒内重定向超过 3 次视为循环 */
const LOOP_WINDOW_MS = 10_000;
const LOOP_THRESHOLD = 3;

/**
 * 判断当前是否处于重定向循环中。
 *
 * 每次调用会递增计数器；如果在 {@link LOOP_WINDOW_MS} 窗口内
 * 计数达到 {@link LOOP_THRESHOLD}，返回 `true`。
 */
export function isRedirectLoop(): boolean {
  const now = Date.now();
  const count = parseInt(sessionStorage.getItem(LOOP_CHECK_KEY) || '0', 10);
  const lastTime = parseInt(sessionStorage.getItem(LOOP_CHECK_TIME) || '0', 10);

  // 超过时间窗口，重置计数
  if (now - lastTime > LOOP_WINDOW_MS) {
    sessionStorage.setItem(LOOP_CHECK_KEY, '1');
    sessionStorage.setItem(LOOP_CHECK_TIME, now.toString());
    return false;
  }

  if (count >= LOOP_THRESHOLD) {
    return true;
  }

  sessionStorage.setItem(LOOP_CHECK_KEY, (count + 1).toString());
  sessionStorage.setItem(LOOP_CHECK_TIME, now.toString());
  return false;
}

/**
 * 清除重定向循环检测状态。
 * 在成功完成导航后调用，防止误判。
 */
export function clearRedirectLoop(): void {
  sessionStorage.removeItem(LOOP_CHECK_KEY);
  sessionStorage.removeItem(LOOP_CHECK_TIME);
}
